import { useDispatch, useSelector } from 'react-redux'
import { setSystemLocalStorage } from '../../redux/action/system'
import { localStorageApi } from '../../helper/localStorageApi'
import { useEffect, useState } from 'react'

export const useLocalStorage = (key, initialValue) => {
	const browserLocalStorage = useSelector(state => state.system.browserLocalStorage)
	const dispatch = useDispatch()
	const [dataFromStorage, setDataFromStorage] = useState(null)
	const [localStorageIsLoaded, setLocalStorageIsLoaded] = useState(false)

	useEffect(() => {
		const data = localStorageApi.getItem(key)
		setDataFromStorage(data)
		setLocalStorageIsLoaded(true)
	}, [key])

	const setValue = (value) => {
		dispatch(setSystemLocalStorage({ [key]: value }))
		localStorageApi.setItem(key, value)
	}

	const getValue = () => {
		const systemLocalStorageValue = browserLocalStorage?.[key]
		const localStorageValue = dataFromStorage
		if (systemLocalStorageValue) {
			return systemLocalStorageValue
		} else if (localStorageValue || localStorageValue === false) {
			return localStorageValue
		} else {
			return initialValue
		}
	}

	const storageValue = getValue()

	return [storageValue, setValue, localStorageIsLoaded]
}
